// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__7K6hn","author":"Table_author__f-nM5","authorImage":"Table_authorImage__3fBaO","unreadRow":"Table_unreadRow__2dlgJ"};